import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "../mock";

function Logo() {
  return (
    <span className="font-head font-extrabold text-xl tracking-tight">
      <span className="text-[var(--rs-red)]">Rajiv</span>{" "}
      <span className="text-[var(--rs-blue)]">Syndicate</span>
    </span>
  );
}

export default function Navbar() {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/90 backdrop-blur-md shadow-[0_1px_0_rgba(0,0,0,0.06)]" : "bg-white/70 backdrop-blur-sm"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="h-[68px] flex items-center justify-between">
          <Link to="/" className="shrink-0"><Logo /></Link>

          <nav className="hidden lg:flex items-center gap-8">
            {NAV_LINKS.map((l) => {
              const active = l.to === "/" ? pathname === "/" : pathname.startsWith(l.to);
              return (
                <Link
                  key={l.to}
                  to={l.to}
                  className={`link-underline text-[15px] font-medium transition-colors ${
                    active ? "text-[var(--rs-blue)] active" : "text-[var(--rs-ink)] hover:text-[var(--rs-blue)]"
                  }`}
                >
                  {l.label}
                </Link>
              );
            })}
          </nav>

          <div className="flex items-center gap-3">
            <Link
              to="/contact"
              className="hidden sm:inline-flex btn-primary rounded-lg px-5 py-2.5 text-sm font-semibold"
            >
              Let's Talk
            </Link>
            <button
              className="lg:hidden p-2 text-[var(--rs-ink)]"
              onClick={() => setOpen((v) => !v)}
              aria-label="Toggle menu"
            >
              {open ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 bg-white border-t border-[var(--rs-border)] ${
          open ? "max-h-[520px]" : "max-h-0"
        }`}
      >
        <nav className="px-6 py-4 flex flex-col">
          {NAV_LINKS.map((l) => {
            const active = l.to === "/" ? pathname === "/" : pathname.startsWith(l.to);
            return (
              <Link
                key={l.to}
                to={l.to}
                className={`py-3 text-base font-medium border-b border-[var(--rs-border)] ${
                  active ? "text-[var(--rs-blue)]" : "text-[var(--rs-ink)]"
                }`}
              >
                {l.label}
              </Link>
            );
          })}
          <Link to="/contact" className="btn-primary rounded-lg px-5 py-3 text-sm font-semibold text-center mt-4">
            Let's Talk
          </Link>
        </nav>
      </div>
    </header>
  );
}
